import {Container} from '~/common/fabric/CreateDesign/components/Container/Container';
import {Envelope} from './Envelope';
import {EnvelopeEditor} from './EnvelopeEditor';
import './Envelope.sass';

export const EnvelopeContainer = () => (
  <Container>
    <Envelope />
    <EnvelopeEditor />
  </Container>
);
